import About from "./components/About";
import Contact from "./components/Contact";
import Home from "./components/Home";
import NavBar from "./components/NavBar";
import Skills from "./components/Skills";
import Work from "./components/Work";

function App() {
  return (
    <div className="overflow-x-hidden">
      <NavBar/>
      <Home/>
      <About/>
      <Skills/>
      <Work />
      <Contact />
    </div>
  );
}

export default App;
